<template>
  <span class="app-counter-rounded">
    {{ count }}
  </span>
</template>

<script>
export default {
  name: 'AppCounterRounded',

  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped>
.app-counter-rounded {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 50px;
  background-color: var(--c-bright-red-500);
  order: 1;
  pointer-events: none;
}
</style>
